import { combineReducers } from 'redux';
import auth from 'auth/reducers/auth.reducer';
import session from 'auth/reducers/session.reducer';
import contact from 'contact/reducers/contact.reducer';
import documents from 'documents/reducers/documents.reducer';
import emailNotificationTemplates from 'email-notification-templates/reducers/email-notification-templates.reducer';
import faq from 'faq/reducers/faq.reducer';
import messages from 'message/reducers/messages.reducer';
import privilegeTemplates from 'privilege-templates/reducers/privilege-templates.reducer';
import registration from 'registration/reducers/registration.reducer';
import reportSubscriptionsPage from 'report-subscriptions/reducers/report-subscriptions-page.reducer';
import sftp from 'report-subscriptions/reducers/sftp.reducer';
import retailerReports from 'retailer-reports/reducers/retailer-reports.reducer';
import adminReports from 'admin-reports/reducers/admin-reports.reducer';
import security from 'security/reducers/security.reducer';
import manageInventory from 'manage-inventory/reducers/manage-inventory.reducer';
import announcements from 'dashboard/reducers/announcements.reducer';
import bigWinners from 'dashboard/reducers/big-winners.reducer';
import bondRenewal from 'dashboard/reducers/bond-renewal.reducer';
import cumulativeWinners from 'dashboard/reducers/cumulative-winners.reducer';
import dashboard from 'dashboard/reducers/dashboard.reducer';
import earningsHistory from 'dashboard/reducers/earnings-history.reducer';
import eftHistory from 'dashboard/reducers/eft-history.reducer';
import licenseRenewal from 'dashboard/reducers/license-renewal.reducer';
import lvmSalesHistory from 'dashboard/reducers/lvm-sales-history.reducer';
import netSales from 'dashboard/reducers/net-sales.reducer';
import siteFinancialStatus from 'dashboard/reducers/site-financial-status.reducer';
import siteOperationalStatus from 'dashboard/reducers/site-operational-status.reducer';
import linkedRetailers from 'user/reducers/linked-retailers.reducer';
import trustedDevices from 'user/reducers/trusted-devices.reducer';
import user from 'user/reducers/user.reducer';
import users from 'user/reducers/users.reducer';
import backendVersion from 'utils/reducers/backend-version.reducer';
import poster from 'utils/reducers/poster.reducer';
import privacyPolicy from 'utils/reducers/privacy-policy.reducer';
import retailerDetails from 'utils/reducers/retailer-details.reducer';
import subordinateList from 'utils/reducers/subordinate-list.reducer';
import termsOfUse from 'utils/reducers/terms-of-use.reducer';
import ui from 'utils/reducers/ui.reducer';
import utils from 'utils/reducers/utils.reducer';
import termsPreview from 'terms-preview/reducers/terms-preview.reducer';
import retailerDashboards from 'retailer-dashboards/reducers/retailer-dashboards.reducer';
import downloadReportPage from 'download-report-page/reducers/download-report-page.reducer';
import app from 'app/reducers/app.reducer';
import banners from 'app/reducers/banners.reducer';
import config from 'app/reducers/config.reducer';
import dictionaries from 'app/reducers/dictionaries.reducer';
import dictionary from 'app/reducers/dictionary.reducer';
import dirtyForms from 'app/reducers/dirty-forms.reducer';
import gameImages from 'app/reducers/game-images.reducer';
import home from 'app/reducers/home.reducer';
import loginPopup from 'app/reducers/login-popup.reducer';
import manageConfigurableLink from 'app/reducers/manage-configurable-link.reducer';
import manageIcons from 'app/reducers/manage-icons.reducer';
import mediaTemplates from 'app/reducers/media-templates.reducer';
import termsManagement from 'app/reducers/terms-management.reducer';
import theme from 'app/reducers/theme.reducer';
import widgets from 'app/reducers/widgets.reducer';


export default combineReducers({
  auth,
	session,
	contact,
	documents,
	emailNotificationTemplates,
	faq,
	messages,
	privilegeTemplates,
	registration,
	reportSubscriptionsPage,
	sftp,
	retailerReports,
	adminReports,
	security,
	manageInventory,
	announcements,
	bigWinners,
	bondRenewal,
	cumulativeWinners,
	dashboard,
	earningsHistory,
	eftHistory,
	licenseRenewal,
	lvmSalesHistory,
	netSales,
	siteFinancialStatus,
	siteOperationalStatus,
	linkedRetailers,
	trustedDevices,
	user,
	users,
	backendVersion,
	poster,
	privacyPolicy,
	retailerDetails,
	subordinateList,
	termsOfUse,
	ui,
	utils,
	termsPreview,
	retailerDashboards,
	downloadReportPage,
	app,
	banners,
	config,
	dictionaries,
	dictionary,
	dirtyForms,
	gameImages,
	home,
	loginPopup,
	manageConfigurableLink,
	manageIcons,
	mediaTemplates,
	termsManagement,
	theme,
	widgets,
	
});



// WEBPACK FOOTER //
// ./src/modules/reducers.js